import React from "react";
import '../Common.scss';
import defaultImage from '../../../assets/default.png';
import styles from './flooring.module.scss';
export default class Flooring extends React.Component<any, any>{

    render() {
        const { pageDetails } = this.props;
        //const images = pageDetails['images'][0];
        const { floorDetailsList, floorAccessoryDetails, floorInstallationDetails, flooringImageUrl, patternImageUrl } = pageDetails?.floorTilesMetaData || {};
        const { elevationImage } = pageDetails || {};
        const floorAccessoryKeys = floorAccessoryDetails ? Object.keys(floorAccessoryDetails) : [];
        return (
            <React.Fragment>
                <div className="page-image-container">
                    <div className="page-heading">{pageDetails?.name}</div>
                    <div className="image-section-container">
                        <img crossOrigin="anonymous" src={elevationImage?.imageUrl ? `${elevationImage?.imageUrl}?ver=${new Date().getTime()}` :defaultImage} alt="" className="image-view" />
                    </div>
                </div>
                <div className="details-heading">FLOORING SPECIFICATIONS</div>
                <div className={styles["tables-alignment"]} style={{margin: "15px"}}>
                    {
                        floorDetailsList && floorDetailsList.length ? 
                            <div className={styles.Table}>
                            <div className={styles.Row}>
                                <div className={styles['Cell']+" "+styles['headings']+' '+styles['cell-left']} style={{borderRight: "none"}}>
                                    <p>{`FLOOR DETAILS`}</p>
                                </div>
                                <div className={styles.Cell} style={{borderLeft: "none"}}>
                                    <p></p>
                                </div>
                            </div>
                                {
                                    (floorDetailsList || []).map(floorDetails=>{
                                        return (Object.keys(floorDetails).length>0 && Object.keys(floorDetails).map(floorKey=>{
                                            if(['pattern', 'collection' ,'brand', 'layingPattern'].includes(floorKey)) {
                                                return
                                            }
                                            return (
                                                    <React.Fragment>
                                                        <div className={styles.Row}>
                                                            <div className={styles['Cell']+" "+styles['headings']+' '+styles['cell-left']}>
                                                                <p>{`${floorKey?.toUpperCase()?.toString()}`}</p>
                                                            </div>
                                                            <div className={styles.Cell+' '+styles['cell-right']}>
                                                                <p>{floorDetails[floorKey] ? floorKey === 'area' ? floorDetails[floorKey]?.toUpperCase()?.toString() : floorDetails[floorKey]?.toUpperCase()?.toString() : "NA"}</p>
                                                            </div>
                                                        </div>
                                                    </React.Fragment>
                                                
                                            )
                                        }))
                                    })
                                }
                    </div> : null
                    }
                    {
                        floorAccessoryKeys && floorAccessoryKeys.length ?
                        <div className={styles.Table}>
                            <div className={styles.Row}>
                                <div className={styles['Cell']+" "+styles['headings']+' '+styles['cell-left']} style={{borderRight: "none"}}>
                                    <p>{`FLOOR ACCESSORY DETAILS`}</p>
                                </div>
                                <div className={styles.Cell} style={{borderLeft: "none"}}>
                                    <p></p>
                                </div>
                            </div>
                        {
                            (floorAccessoryKeys || []).map(accKey=>{
                                let accessory = floorAccessoryDetails[accKey];
                                return(
                                    <div className={styles.Row}>
                                        <div className={styles['Cell']+" "+styles['headings']+' '+styles['cell-left']}>
                                            <p>{`${accKey?.toUpperCase()?.toString()}`}</p>
                                        </div>
                                        <div className={styles.Cell+' '+styles['cell-right']}>
                                            <p>{accessory ? accessory?.toUpperCase()?.toString() : "NA"}</p>
                                        </div>
                                    </div>
                                )
                            })
                            
                        }
                        </div> :null
                    }
                    <div className={styles.Table}>
                                    <div className={styles.Row}>
                                        <div className={styles['Cell']+" "+styles['headings']+' '+styles['cell-left']} style={{borderRight: "none"}}>
                                            <p>{`FLOOR INSTALLATION`}</p>
                                        </div>
                                        <div className={styles.Cell+' '+styles['cell-right']} style={{borderLeft: "none"}}>
                                            <p></p>
                                        </div>
                                    </div>
                    {
                        (floorInstallationDetails && Object.keys(floorInstallationDetails).map(fi=>{
                            return(
                                    <div className={styles.Row}>
                                        <div className={styles['Cell']+" "+styles['headings']+' '+styles['cell-left']}>
                                            <p>{`${fi?.toUpperCase()?.toString()}`}</p>
                                        </div>
                                        <div className={styles.Cell+' '+styles['cell-right']}>
                                            <p>{floorInstallationDetails[fi] ? floorInstallationDetails[fi]?.toUpperCase()?.toString() : "NA"}</p>
                                        </div>
                                    </div>
                            )
                        }))
                    }
                    </div>
                    {
                        <div className={styles.Table+' '+styles['imageTables']}>
                            <div className={styles.Row}>
                                <div className={styles['Cell']+" "+styles['headings']}>
                                        <p>{"FLOOR IMAGE"}</p>
                                        {
                                            
                                            <img crossOrigin="anonymous" alt="flooringImage" src={ flooringImageUrl ? `${flooringImageUrl}?ver=${new Date().getTime()}`: defaultImage } width="75px" height="70px" /> 
                                        }
                                </div>
                                <div className={styles['Cell']+" "+styles['headings']}>
                                    <p>{"PATTERN IMAGE"}</p>
                                    {
                                        <img crossOrigin="anonymous" alt="patternImage" src={ patternImageUrl ? `${patternImageUrl}?ver=${new Date().getTime()}`: defaultImage } width="75px" height="70px" /> 
                                    }
                                </div>
                            </div>  
                        </div>
                    }
                </div>
                
            </React.Fragment>

        )
    }

}